module.exports = __webpack_public_path__ + "img/male-youngadult-figure.e5bda130.svg";